/**
 * 底部导航栏组件
 * 移动端底部3个主要功能：首页、视频处理、我的
 */

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUser, type UserRole } from '../utils/auth';
import './BottomNavigation.css';

const BottomNavigation: React.FC = () => {
  const [userRole, setUserRole] = useState<UserRole>('user');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 获取用户角色
    const user = getUser();
    if (user) {
      setUserRole(user.role || 'user');
    }
  }, [location.pathname]);

  const handleNavigate = (path: string) => {
    // 如果当前已经在目标路由且查询参数一致，则不重复跳转
    if (path === '/profile') {
      const curTab = new URLSearchParams(location.search).get('tab') || 'management';
      if (location.pathname === '/profile' && curTab === 'management') return;
      navigate('/profile?tab=management');
      return;
    }
    if (location.pathname === path) return;
    navigate(path);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  // 检查是否有上传权限
  const hasUploadPermission = userRole === 'premium' || userRole === 'super' || userRole === 'admin';

  return (
    <div className="bottom-navigation">
      
      <div className="bottom-nav-item" onClick={() => handleNavigate('/')}>
        <div className={`nav-icon ${isActive('/') ? 'active' : ''}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
        <span className={`nav-label ${isActive('/') ? 'active' : ''}`}>首页</span>
      </div>

      <div
        className={`bottom-nav-item ${hasUploadPermission ? '' : 'disabled'}`}
        onClick={() => hasUploadPermission && handleNavigate('/upload')}
      >
        <div className={`nav-icon ${isActive('/upload') ? 'active' : ''}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </div>
        <span className={`nav-label ${isActive('/upload') ? 'active' : ''}`}>上传</span>
      </div>

      <div className="bottom-nav-item" onClick={() => handleNavigate('/profile')}>
        <div className={`nav-icon ${isActive('/profile') ? 'active' : ''}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <span className={`nav-label ${isActive('/profile') ? 'active' : ''}`}>我的</span>
      </div>
    </div>
  );
};

export default BottomNavigation;

